import React, { useEffect } from 'react'
import { Box, Stack } from '@mui/material'
import { useSessionContext } from 'session'
import { CommitteeCreateCard } from 'components'
import { useParams } from 'react-router-dom'

export const CommitteeCreatePage: React.FC = () => {
  const { changeModuleName, changeUniqueId } = useSessionContext()
  const { parentId } = useParams<{ parentId: string }>()
  const parsedParentId = parentId != null ? parseInt(parentId, 10) : undefined

  const isSubcommittee = parsedParentId != null

  useEffect(() => {
    changeModuleName(`Create ${isSubcommittee ? 'Sub' : ''}Committee${isSubcommittee ? ' for' : ''}`)
    if (!isSubcommittee) {
      changeUniqueId('')
    }
  }, [changeModuleName, isSubcommittee])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        mt: 1
      }}
    >
      <Stack spacing={2} alignItems="center" mt={1} width="98%">
        <CommitteeCreateCard parentId={parsedParentId} />
      </Stack>
    </Box>
  )
}
